import { endpointsList } from '@/helpers';
import axios, { AxiosResponse } from 'axios';
import {
  ISupplier,
  ISuppliersSummaryPageDto,
  ISuppliersSummaryPageOptionsDto,
  Serialized,
} from 'types';

export class SuppliersService {
  public static async getSuppliersForProject<T extends keyof ISupplier>(
    projectId: string,
    fields?: T[],
  ): Promise<Array<Serialized<Pick<ISupplier, T>>>> {
    const response: AxiosResponse<Array<Serialized<Pick<ISupplier, T>>>> =
      await axios.get(
        endpointsList.projects.getProjectSuppliersById(projectId, fields),
      );
    return response.data;
  }

  public static async getSupplierName(supplierId: string): Promise<string> {
    const response: AxiosResponse<string> = await axios.get(
      endpointsList.suppliers.getSupplierNameById(supplierId),
    );
    return response.data;
  }

  static async getSuppliersList(pageOptions: ISuppliersSummaryPageOptionsDto) {
    const response = await axios.get<ISuppliersSummaryPageDto>(
      endpointsList.suppliers.getSuppliersSummary(pageOptions),
    );
    return response.data;
  }
}
